

import Carousel, { CarouselResponsiveOptions } from 'primevue/carousel';
import { ref } from 'vue';

export default {
	name: 'CarouselGame2',
	components: {
		Carousel,
	},
	setup() {
		const products = ref([
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-1.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-2.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-3.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-4.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-5.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-6.webp',
				name: 'name',
				href: '/slot',
			},
			{
				image: 'https://snc168.sgp1.digitaloceanspaces.com/theme/prod-7.webp',
				name: 'name',
				href: '/slot',
			},
		]);

		const responsiveOptions = ref<CarouselResponsiveOptions[]>([
			{
				breakpoint: '1400px',
				numVisible: 5,
				numScroll: 1
			},
			{
				breakpoint: '1199px',
				numVisible: 4,
				numScroll: 1
			},
			{
				breakpoint: '767px',
				numVisible: 2,
				numScroll: 1
			},
			{
				breakpoint: '575px',
				numVisible: 1,
				numScroll: 1
			}
		]);


		return {
			products,
			responsiveOptions,
		}
	}
}
